import { CanAccess } from 'react-admin';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { type ComponentType, lazy } from 'react';

import { resources } from '@repo/c360-ra-components';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  <CanAccess resource={resources.bankCards} action="list">
    <AsyncPageList />
  </CanAccess>
);

const protectedShow = () => (
  <CanAccess resource={resources.bankCards} action="show">
    <AsyncPageShow />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  show: protectedShow as ComponentType<any>,
  icon: ReceiptIcon,
};
